import { onRendered, toast } from '../runtime/legacy.js';
import { resetRedirectTarget } from './password-reset.js';

/**
 * Adds the two auth affordances the store review checklists expect and the
 * legacy signup/login views are missing: password confirmation and a
 * self-service password reset.
 */

function enhanceSignup(form) {
  const password = form.querySelector('#signup-password');
  if (!password) return;

  const group = document.createElement('div');
  group.className = 'form-group';
  group.innerHTML = `
    <label class="form-label" for="signup-confirm-password">Confirm Password</label>
    <input type="password" class="form-input" id="signup-confirm-password"
           placeholder="Re-enter your password" autocomplete="new-password" required>
  `;
  password.closest('.form-group').after(group);

  // Capture phase so this runs before the core's own submit handler and can
  // stop it from creating an account with a mistyped password.
  form.addEventListener(
    'submit',
    (event) => {
      const confirm = form.querySelector('#signup-confirm-password');
      const error = form.querySelector('#signup-error');
      if (password.value === confirm.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (error) {
        error.textContent = 'Passwords do not match.';
        error.style.display = 'block';
      } else {
        toast('Passwords do not match.', 'error');
      }
    },
    true,
  );
}

function enhanceLogin(form) {
  const password = form.querySelector('#login-password');
  if (!password) return;

  const wrap = document.createElement('div');
  wrap.className = 'auth-forgot-row';
  wrap.innerHTML = '<a href="#" id="forgot-pw-link">Forgot password?</a>';
  password.closest('.form-group').after(wrap);

  wrap.querySelector('#forgot-pw-link').addEventListener('click', async function (event) {
    event.preventDefault();

    const email = (form.querySelector('#login-email')?.value || '').trim();
    if (!email) {
      toast('Enter your email address first', 'error');
      return;
    }

    const client = globalThis.supabaseClient;
    if (!client) {
      toast('Password reset is unavailable in demo mode', 'error');
      return;
    }

    const label = this.textContent;
    this.textContent = 'Sending…';
    try {
      // No fragment in the redirect target, and no `#/reset-password` route
      // named here: password-reset.js owns both, and owns why. Sending the
      // wrong shape is what broke this before — see the note at the top of it.
      const { error } = await client.auth.resetPasswordForEmail(email, {
        redirectTo: resetRedirectTarget(window.location),
      });
      if (error) throw error;
      toast('Password reset email sent! Check your inbox.', 'success', 5000);
      this.textContent = 'Email sent ✓';
    } catch (err) {
      toast(`Could not send reset email: ${err.message || err}`, 'error');
      this.textContent = label;
    }
  });
}

export function installAuthForms() {
  onRendered('#signup-form', enhanceSignup);
  onRendered('#login-form', enhanceLogin);
}
